export default __webpack_public_path__ + "static/media/giphy.728bf565.gif";